import React from 'react';

import * as St from './styles';

function ButtonBack({onClick,...others}) {
  return <St.Button {...others} onClick={onClick}/>;
}

export default ButtonBack;